import {createRoot} from "react-dom/client";

function conditionallyRenderReact(renderRootSelector: string, reactComponent: React.ReactNode, data: any) {
  const renderRoot = document.getElementById(renderRootSelector);
  if (renderRoot && data) {
    createRoot(renderRoot).render(reactComponent)
  }
}

export {conditionallyRenderReact}